import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import OuvidoriaService from '../../../services/ouvidoria-auth';
import Requisicao from './requisicao';


const ListarRequisicoes = () => {


    const [requisicoes, setRequisicoes] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [error, setError] = useState();
    const [requisicao, setRequisicao] = useState("");



    async function fetchRequisicoesIn() {
        const response = await OuvidoriaService.listar({ esic: false });
        if (response.data.length >= 1) {
            setRequisicoes(response.data)
            setVazio(false)
        } else {
            setRequisicoes([])
            setVazio(true)
        }
    }

    const corrigir = async (id) => {
        try {
            const ouvidoria = await OuvidoriaService.corrigir(id);
            alert("Situação atualizada com sucesso!")
            setError(false)
        } catch (error) {
            setError(error)
        }
    }


    useEffect(() => {
        fetchRequisicoesIn();
    }, []);

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a requisição?')) {
            await OuvidoriaService.deletar(id)
            alert("Requisição deletada com sucesso!")
            fetchRequisicoesIn();
        }
    }

    const handleEditar = (id) => {
        setRequisicao(id);
        setEditar(true)
    }


    if (editar) {
        return (
            <Navigate to={`/restrito/ouvidoria/editar/${requisicao}`} />
        )
    } else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setRequisicoes={setRequisicoes}
                        setVazio={setVazio}
                        fetchRequisicoesIn={fetchRequisicoesIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={2}>
                            {requisicoes.map((requisicao, index) =>
                                <Requisicao
                                    fetchRequisicoesIn={fetchRequisicoesIn}
                                    requisicao={requisicao}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                    corrigir={corrigir}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarRequisicoes;